export default function () {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    { label: "公众号openid", prop: "gzh_openid", slots: "gzh_openid", width: 300 },
    { label: "小程序openid", prop: "xcx_openid", slots: "xcx_openid", width: 300 },
    { label: "手机号", prop: "phone", width: 200 },
    { label: "模版", prop: "template_id", slots: "template_id", width: 300 },
    {
      label: "创建时间",
      prop: "create_time",
      width: 180,
    },
    {
      label: "操作",
      prop: "operation",
      width: 150,
      slots: "operation",
      fixed: "right",
    },
  ];
}
